import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { find } from 'lodash';

interface ValueListRowInterface {
  id: string;
  description: string;
  name: string;
  timestampInserted: string;
  timestampUpdated: string;
  token: string;
  values: string[];
}

const slice = createSlice({
  name: 'valueList',
  initialState: {
    list: [],
    reasonFilters: []
  },
  reducers: {
    listReceived(valueList: any, action: PayloadAction<any>) {
      const payload: any = action.payload;

      if (payload.rows && payload.rows.length > 0) {
        valueList.list = payload.rows;
      } else {
        valueList.list = [];
      }
    }
  }
});

export const { listReceived } = slice.actions;
export default slice.reducer;

/**
 * Gets list by name.
 */
export const getListByName =
  (name: string = '') =>
  (dispatch: any, getState: any) => {
    const { list } = getState().entities.catalogs.valueList;

    if (name === '') {
      return [];
    }

    const object = find(list, function (o: any) {
      return o.name.toLowerCase() === name.toLowerCase();
    });

    if (object) {
      return object.values;
    }

    return [];
  };

export const makeGetListByName = (name: string) =>
  createSelector(
    (state: any) => state.entities.catalogs.valueList.list,
    (list: ValueListRowInterface[]) => {
      const obj = list.find(
        (o: ValueListRowInterface) =>
          o.name.toLowerCase() === name.toLowerCase()
      );
      return obj ? obj.values : [];
    }
  );

const riskCauseTypes = makeGetListByName('Risk_Cause_Type');

export const getRiskCauseTypesOrdered = createSelector(
  riskCauseTypes,
  (values: string[]) => {
    const causeTypes = process.env.REACT_APP_RISK_CAUSE_TYPES?.split(',') || [];
    const factors = process.env.REACT_APP_RISK_FACTORES?.split(',') || [];

    const causeTypeFiltered = causeTypes.filter((value) =>
      values.includes(value)
    );
    const factorsFiltered = factors.filter((value) => values.includes(value));

    return {
      causeTypes: causeTypeFiltered,
      factors: factorsFiltered
    };
  }
);
